/** Google Analytics measurement ID used for all gtag calls. */
export const GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-PKJB4D3CJW";
